import type { Components, Theme } from "@mui/material/styles";

export const MuiRadio: Components<Theme>["MuiRadio"] = {
  defaultProps: {
    color: "primary",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
    }),
  },
};
